import './dx-styles.scss';
import 'devextreme/dist/css/dx.common.css';

import { NavigationProvider } from './contexts/navigation';
import { useScreenSizeClass } from './utils/media-query';
import { ThemeContext, useThemeContext } from "./themes/theme";
import config from 'devextreme/core/config';
import { licenseKey } from './devextreme-licence.js';
import { Content } from './Content';
import { locale, loadMessages } from 'devextreme/localization';
import itMessages from 'devextreme/localization/messages/it.json';
import { BrowserRouter as Router } from 'react-router-dom';
import { AuthenticationProvider } from './contexts/AuthenticationContext';

config({ licenseKey });

export default function Root() {
    const themeContext = useThemeContext();
    const screenSizeClass = useScreenSizeClass();

    loadMessages(itMessages);
    locale(navigator.language);
    config({
        defaultCurrency: 'EUR',
        defaultUseCurrencyAccountingStyle: false
    });


    return (
        <Router>
            <ThemeContext.Provider value={themeContext}>
                <AuthenticationProvider>
                    <NavigationProvider>
                        <div className={`app ${screenSizeClass}`}>
                            <Content />
                        </div>
                    </NavigationProvider>
                </AuthenticationProvider>
            </ThemeContext.Provider>
        </Router>
    );
}